// extracted by mini-css-extract-plugin
export default {"loader":"AppLoader_loader__ABbe9"};